// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileHome_mobile_home_container__UaeBo {
  display: flex;
  height: 100vh;
  width: 100%;
  flex-direction: column;
}
.MobileHome_mobile_home_add__bkmUc {
  flex-shrink: 0;
  padding: 20px;
  text-align: right;
  font-size: 24px;
  color: #74bdc6;
}
.MobileHome_mobile_home_main__aG1qD {
  flex: 1 1;
  overflow: hidden;
}
.MobileHome_mobile_ios_home_add__EENMM {
  padding: 60px 20px 20px!important;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/MobileHome/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC","sourcesContent":[".mobile_home_container {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  flex-direction: column;\n}\n.mobile_home_add {\n  flex-shrink: 0;\n  padding: 20px;\n  text-align: right;\n  font-size: 24px;\n  color: #74bdc6;\n}\n.mobile_home_main {\n  flex: 1;\n  overflow: hidden;\n}\n.mobile_ios_home_add {\n  padding: 60px 20px 20px!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile_home_container": `MobileHome_mobile_home_container__UaeBo`,
	"mobile_home_add": `MobileHome_mobile_home_add__bkmUc`,
	"mobile_home_main": `MobileHome_mobile_home_main__aG1qD`,
	"mobile_ios_home_add": `MobileHome_mobile_ios_home_add__EENMM`
};
export default ___CSS_LOADER_EXPORT___;
